const agentForm = $('#agent-submit-form');
const counselorForm = $('#counselor-submit-form');
const vendorForm = $('#vendor-submit-form');
if (agentForm.length === 1){
    agentForm.change(function(){
        const years_operating_value = $("input[name='years_operating']:checked").val();
        const years_operating_other = $("#years_operating_other");
        if (years_operating_value === '4'){
            years_operating_other.show();
        } else {
            years_operating_other.hide();
        }

        const institutional_partners_value = $("input[name='institutional_partners']:checked").val();
        const institutional_partners_other = $("#institutional_partners_other");
        if (institutional_partners_value === '4'){
            institutional_partners_other.show();
        } else {
            institutional_partners_other.hide();
        }

        $('.inline-input-wrapper').hide();
        $('#study_level_placements_other').hide();
        $('#top_destination_placements_other').hide();

        const study_level_placements_values = $("input[name='study_level_placements[]']:checked");
        study_level_placements_values.each(function() {
            $(`.study_level_placements_${this.value}_students`).show();
            if (this.value === '6'){
                $('#study_level_placements_other').show();
            }
        });

        const top_destination_placements_values = $("input[name='top_destination_placements[]']:checked");
        top_destination_placements_values.each(function() {
            $(`.top_destination_placements_${this.value}_students`).show();
            if (this.value === '6'){
                $('#top_destination_placements_other').show();
            }
        });
    });
}
if (counselorForm.length === 1) {
    counselorForm.change(function (){
        $('.inline-input-wrapper').hide();
        $('#school_desc_other').hide();
        $('#activities_other').hide();
        $('#top_destination_placements_other').hide();

        const school_desc_values = $("input[name='school_desc[]']:checked");
        school_desc_values.each(function() {
            if (this.value === '8'){
                $('#school_desc_other').show();
            }
        });

        const activities_values = $("input[name='activities[]']:checked");
        activities_values.each(function() {
            if (this.value === '6'){
                $('#activities_other').show();
            }
        });

        const top_destination_placements_values = $("input[name='top_destination_placements[]']:checked");
        top_destination_placements_values.each(function() {
            $(`.top_destination_placements_${this.value}_students`).show();
            if (this.value === '7'){
                $('#top_destination_placements_other').show();
            }
        });


    })
}
if (vendorForm.length === 1){
    vendor_form_fields_init();
    vendorForm.change(function(){
        vendor_form_fields_init();
    });
}

function vendor_form_fields_init(){
    const education_agents_options = $('.education-agents-options');
    education_agents_options.hide();

    const education_agents_enable = $("input[name='education_agents_enable']:checked").val();
    if (education_agents_enable === 'yes') {
        education_agents_options.show();
    }

    const global_coverage_value = $("input[name='global_coverage']:checked").val();
    const global_coverage_other = $("#global_coverage_other");
    if (global_coverage_value === '3'){
        global_coverage_other.show();
    } else {
        global_coverage_other.hide();
    }

    const organizations_member_values = $("input[name='organizations_member[]']:checked");
    organizations_member_values.each(function() {
        if (this.value === '4'){
            $('#organizations_member_other').show();
        }
    });
}